import { StateCreator, StoreApi } from 'zustand';
import { State, Actions, NotificationStore } from './types';
import { ResourceMapperNotificationTypes } from '../../../types';
import { mapNotificationMessage } from '../../../utils/mapNotificationMessage';
import { ResourceMapperStore } from '../../ResourceMapperStoreTypes';

const initialState: State = {
  notification: null,
};

const actions = (set: StoreApi<ResourceMapperStore>['setState']): Actions => ({
  setNotification: (note_type?: ResourceMapperNotificationTypes, note?: any) => {
    const notification = mapNotificationMessage(note_type, note);
    set({ notification });
  },
  clearNotification: () => {
    set({ notification: null });
  },
});

export const createNotificationsSlice: StateCreator<NotificationStore> = (set) => ({
  ...initialState,
  ...actions(set),
});

export type NotificationSlice = ReturnType<typeof createNotificationsSlice>;
